import React, { Component } from 'react';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import TransferWidget from './TransferWidget';
import ExerciseWidget from './ExerciseWidget';
import OptyIconButton from './OptyIconButton';
import Icon from 'material-ui/Icon';
import withSubscription from './withSubscription';
import * as r from 'ramda';
import api from './api';

class Holdings extends Component {
  render() {
    const { holdings, account, network } = this.props;
    const baseurl = api.config.etherscan[network.network];
    const now = Math.floor(Date.now() / 1000);

    if (holdings._refreshing === false) {
      const sorted = r.sortBy(r.prop('expiration'), Object.values(holdings.value));

      return (
        <div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell colSpan={3} style={{textAlign:'center'}}>Underwriters</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Holding</TableCell>
              <TableCell>Actions</TableCell>
              <TableCell>Outstanding</TableCell>
              <TableCell>Exercised</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {sorted.map(option => (
            <TableRow key={option.address}>
              <TableCell>
                <a href={baseurl + "/token/" + option.address + "?a=" + account.account} target="etherscan">
                <Icon>launch</Icon>
                </a>
              </TableCell>
              <TableCell>{option.name}</TableCell>
              <TableCell numeric>{option.balance.toString()}</TableCell>
              <TableCell style={{textAlign:'center'}}>
                <OptyIconButton tooltip="Exercise" onClick={()=>this.exerciseWidget.run(option.address)} icon='transform' disabled={option.balance.lte(0)}/>
                &nbsp;&nbsp;
                <OptyIconButton tooltip="Transfer" onClick={()=>this.transferWidget.run(option.address)} icon='send' disabled={option.balance.lte(0)}/>
              </TableCell>
              <TableCell numeric>{option.outstanding.toString()}</TableCell>
              <TableCell numeric>{option.exercised.toString()}</TableCell>
              <TableCell style={{textAlign:'center'}}>
                <OptyIconButton tooltip="Withdraw" onClick={()=>option.withdrawAll()} icon='file_download' disabled={option.outstanding.lte(0) || (option.exercised.lte(0) && option.expiration > now)}/>
              </TableCell>
            </TableRow>
          ))}
          </TableBody>
        </Table>
        <TransferWidget ref = { widget => {this.transferWidget = widget }}/>
        <ExerciseWidget ref={widget => {this.exerciseWidget = widget}}/>
        </div>
      );
    } else {
      return (<div>Loading...</div>);
    }
  }
}

export default withSubscription(() => ({ holdings: api.holdings, account: api.account, network: api.network }))(Holdings);


// WEBPACK FOOTER //
// ./src/Holdings.js